'use client';

import { c as _c } from "react/compiler-runtime";
import { type Space, Types } from '@shared/all/domains/spaces';
import { type Upload } from '@shared/all/domains/uploads';
import useSpace from '@shared/utils/hooks/useSpace';
import Link from 'next/link';
import { useState } from 'react';
import { type RouterOutputs } from '../../utils/trpc';
import SpaceMedia from '../common/Media';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
type Props = {
  copyLinkHandler: () => void;
  slug: string;
  loggedIn: boolean;
  filtered: boolean | undefined;
  filterChangeHandler: (type: 'add' | 'remove') => void;
  reportClickHandler: () => void;
  types: Space['types'];
  isInvited: boolean;
  joinHandler: () => void;
  leaveHandler: () => void;
  openEmbedModal: () => void;
  closeHandler: () => void;
  uploads: Upload[] | undefined;
  space: RouterOutputs['spaces']['get'];
  editHandler?: () => void;
  showHistoryLink?: boolean;
  // Board spaces only: replays the development board tour
  onTakeTour?: () => void;
};
const SpaceDropdown = props => {
  const $ = _c(68);
  const {
    isOwner,
    isModerator
  } = useSpace();
  const [showSpaceMedia, setShowSpaceMedia] = useState(false);
  let t0;
  if ($[0] !== props.isInvited || $[1] !== props.joinHandler || $[2] !== props.space.membership || $[3] !== props.space.types) {
    t0 = !props.space.membership && !props.space.types.includes(Types.PRIVATE) && (!props.space.types.includes(Types.INVITE) && !props.space.types.includes(Types.PAID) || props.isInvited) && <button className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" onClick={props.joinHandler}>Join Space</button>;
    $[0] = props.isInvited;
    $[1] = props.joinHandler;
    $[2] = props.space.membership;
    $[3] = props.space.types;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== props.isInvited || $[6] !== props.joinHandler || $[7] !== props.space.membership || $[8] !== props.space.types) {
    t1 = !props.space.membership && props.space.types.includes(Types.INVITE) && !props.isInvited && <div className=""><button className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" onClick={props.joinHandler}>Join Space</button><span className="ml-2">This is an invite-only community</span></div>;
    $[5] = props.isInvited;
    $[6] = props.joinHandler;
    $[7] = props.space.membership;
    $[8] = props.space.types;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== isOwner || $[11] !== props.leaveHandler || $[12] !== props.space) {
    t2 = props.space.membership && !props.space.types.includes(Types.PRIVATE) && <button title="Leave Space" className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" disabled={isOwner(props.space)} onClick={props.leaveHandler}>Leave Space</button>;
    $[10] = isOwner;
    $[11] = props.leaveHandler;
    $[12] = props.space;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== isOwner || $[15] !== props.leaveHandler || $[16] !== props.space) {
    t3 = props.space.membership?.expires === null && props.space.types.includes(Types.PAID) && <button title="Cancel Membership" className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" disabled={isOwner(props.space)} onClick={props.leaveHandler}>Cancel Membership</button>;
    $[14] = isOwner;
    $[15] = props.leaveHandler;
    $[16] = props.space;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== props.space.membership || $[19] !== props.space.types) {
    t4 = props.space.membership && props.space.membership.expires !== null && new Date(props.space.membership.expires ?? 0) >= new Date() && props.space.types.includes(Types.PAID) && <button className="w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" disabled={true}>{`Expires on ${new Date(props.space.membership.expires ?? 0).toLocaleDateString()}`}</button>;
    $[18] = props.space.membership;
    $[19] = props.space.types;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== showSpaceMedia) {
    t5 = <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light md:hidden" onClick={() => setShowSpaceMedia(!showSpaceMedia)}>Space Media</button>;
    $[21] = showSpaceMedia;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const t6 = `/s/${props.space.spaceSlug}/history`;
  let t7;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="ml-2">Space History</span>;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t6) {
    t8 = <Link href={t6} className="flex items-center rounded-md px-2 py-2.5 md:hidden">{t7}</Link>;
    $[24] = t6;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== props.copyLinkHandler) {
    t9 = <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={props.copyLinkHandler}>Copy link to Space</button>;
    $[26] = props.copyLinkHandler;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== props.openEmbedModal) {
    t10 = <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={props.openEmbedModal}>Embed Space</button>;
    $[28] = props.openEmbedModal;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== props) {
    t11 = props.loggedIn && props.slug !== "factiii" && <>{!props.filtered && <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={() => props.filterChangeHandler("add")}>Add Space as filter</button>}{props.filtered && <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={() => props.filterChangeHandler("remove")}>Remove Space as filter</button>}</>;
    $[30] = props;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== isOwner || $[33] !== props) {
    t12 = isOwner(props.space) && props.editHandler && <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={() => {
      props.closeHandler();
      props.editHandler?.();
    }}>Edit Space</button>;
    $[32] = isOwner;
    $[33] = props;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== isModerator || $[36] !== isOwner || $[37] !== props.slug || $[38] !== props.space) {
    t13 = (isOwner(props.space) || isModerator(props.space)) && <><Link href={`/s/${props.slug}/manage/${isOwner(props.space) ? "availability" : "moderators"}`}><button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light">Manage Space</button></Link><Link href={`/moderation/${props.slug}`}><button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light">Moderation center</button></Link></>;
    $[35] = isModerator;
    $[36] = isOwner;
    $[37] = props.slug;
    $[38] = props.space;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== props.loggedIn || $[41] !== props.showHistoryLink || $[42] !== props.slug) {
    t14 = props.loggedIn && props.showHistoryLink && <Link href={`/s/${props.slug}/history`}><button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light">History</button></Link>;
    $[40] = props.loggedIn;
    $[41] = props.showHistoryLink;
    $[42] = props.slug;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== props) {
    t15 = false && props.onTakeTour && <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={() => {
      props.closeHandler();
      props.onTakeTour?.();
    }}>Take the board tour</button>;
    $[44] = props;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== props.reportClickHandler) {
    t16 = <button className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light" onClick={props.reportClickHandler}>Report Space</button>;
    $[46] = props.reportClickHandler;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== props.uploads || $[49] !== showSpaceMedia) {
    t17 = showSpaceMedia && <Modal closeHandler={() => setShowSpaceMedia(false)}><ModalHeader><h2>Space Media</h2></ModalHeader><ModalContent>{props.uploads ? <SpaceMedia data={props.uploads} /> : <div className="text-center text-textSecondary/70">No media files to show</div>}</ModalContent></Modal>;
    $[48] = props.uploads;
    $[49] = showSpaceMedia;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== t0 || $[52] !== t1 || $[53] !== t10 || $[54] !== t11 || $[55] !== t12 || $[56] !== t13 || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t17 || $[61] !== t2 || $[62] !== t3 || $[63] !== t4 || $[64] !== t5 || $[65] !== t8 || $[66] !== t9) {
    t18 = <div className="w-48 rounded-md border border-ds-border-standard bg-background-primary p-2 shadow-md">{t0}{t1}{t2}{t3}{t4}{t5}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</div>;
    $[51] = t0;
    $[52] = t1;
    $[53] = t10;
    $[54] = t11;
    $[55] = t12;
    $[56] = t13;
    $[57] = t14;
    $[58] = t15;
    $[59] = t16;
    $[60] = t17;
    $[61] = t2;
    $[62] = t3;
    $[63] = t4;
    $[64] = t5;
    $[65] = t8;
    $[66] = t9;
    $[67] = t18;
  } else {
    t18 = $[67];
  }
  return t18;
};
export default SpaceDropdown;